/* eslint-disable */
<template>
  <v-app>
    <v-toolbar dark class="yellow darken-4">
        <v-icon dark> explore </v-icon><v-toolbar-title left><router-link to="/" tag="span" style="cursor: pointer">CometLabs</router-link> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-xs-only">
          <v-btn
            flat
            v-for="item in menuItems"
            :key="item.title"
            :to="item.link">
            <v-icon left dark>{{ item.icon }}</v-icon>
            {{ item.title }}

          </v-btn>

          <v-btn
            v-if="userIsAuthenticated"
            flat
            @click="onLogout">
            <v-icon left dark>exit_to_app</v-icon>
            Logout

          </v-btn>
        </v-toolbar-items>

    </v-toolbar>
    <main>
      <router-view></router-view>
    </main>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      user: '',
      role: ''
    }
  },
  computed: {
      menuItems () {
        let menuItems = [
          {icon: 'location_on', title: 'Browse', link: '/Browse'},
          {icon: 'face', title: 'Sign up', link: '/signup'},
          {icon: 'lock_open', title: 'Sign in', link: '/signin'}
        ]

        if (this.userIsAuthenticated) {
          menuItems = [
            {icon: 'location_on', title: 'Browse', link: '/Browse'},
            {icon: 'person', title: 'Profile', link: '/profile'}
          ]
        }

        return menuItems
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    },
  methods: {
    onLogout () {
        this.$store.dispatch('logout')
    }
  },
  created (){
    const user = this.$store.getters.user
    console.log(user.id)
    this.user = user.id
    this.$store.dispatch('getUserRole', user.id)
  },
  mounted(){
    this.role = this.$store.getters.role
  }

}
</script>
